import { Forms, FormsSchema } from '@/apis/family_application/requests'
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from 'react-router-dom'
import { z } from 'zod'
const MemberSchema = z.union([z.literal('partner'), z.literal('user')])

type Member = z.infer<typeof MemberSchema>

type ValidParams = {
  selectedOption: Forms | null
  selectedMember?: Member | null
}

function useUploadParams() {
  const [params] = useSearchParams()
  const navigate = useNavigate()

  function updateParams(route: string, params?: ValidParams) {
    const searchParams: Record<string, string> = {}

    if (params?.selectedOption) {
      searchParams.selectedOption = params.selectedOption
    }

    if (params?.selectedMember) {
      searchParams.selectedMember = params.selectedMember
    }

    navigate({
      pathname: route,
      search: createSearchParams({
        ...searchParams,
      }).toString(),
    })
  }

  const selectedOptionParam = params.get('selectedOption')
  const selectedMemberParam = params.get('selectedMember')
  const validatedOption = FormsSchema.safeParse(selectedOptionParam)
  const validatedMember = MemberSchema.safeParse(selectedMemberParam)

  const selectedOption = validatedOption.success ? validatedOption.data : null
  const selectedMember = validatedMember.success ? validatedMember.data : null

  return { selectedOption, selectedMember, updateParams }
}

export default useUploadParams
